import { useEffect, useEffectEvent, useState } from 'react';
import { getButtonText } from '../logic/subscriptionChange.logic';
import { useSubscriptionChange } from './useSubscriptionChange';

export const useChangePlanModal = (isOpen: boolean, onClose: () => void) => {
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    // Use the core subscription change hook
    const subscriptionChange = useSubscriptionChange({
        onSuccess: () => {
            setShowConfirmationModal(false);
            onClose();
        },
    });

    const {
        currentTier,
        currentInterval,
        newTier,
        newInterval,
        hasPlanBeenEdited,
        subscriptionIsCancelled,
        platformSubscriptionId,
        reset,
        requestEstimate,
    } = subscriptionChange;

    // Reset selections when modal opens
    const handleReset = useEffectEvent(() => {
        reset();
        setShowConfirmationModal(false);
    });

    const handleRequestEstimate = useEffectEvent(() => {
        requestEstimate();
    });

    useEffect(() => {
        if (isOpen) {
            handleReset();
        }
    }, [isOpen]);

    // Trigger estimate when selection changes or when subscription is cancelled
    useEffect(() => {
        if (isOpen && platformSubscriptionId && (hasPlanBeenEdited || subscriptionIsCancelled)) {
            handleRequestEstimate();
        }
    }, [hasPlanBeenEdited, platformSubscriptionId, subscriptionIsCancelled, isOpen]);

    const handleConfirm = () => {
        setShowConfirmationModal(true);
    };

    const handleConfirmationConfirm = () => {
        subscriptionChange.executeChange();
    };

    const handleConfirmationGoBack = () => {
        setShowConfirmationModal(false);
    };

    const handleConfirmationClose = () => {
        setShowConfirmationModal(false);
        onClose();
    };

    const buttonText = getButtonText({
        currentTier,
        newTier,
        currentInterval,
        newInterval,
        isCancelled: subscriptionIsCancelled,
    });

    return {
        ...subscriptionChange,
        showConfirmationModal,
        buttonText,
        handleConfirm,
        handleConfirmationConfirm,
        handleConfirmationGoBack,
        handleConfirmationClose,
    };
};
